const PPTX_HANDOFF_ERROR = "美化 PPT 时，资料列表中只能保留 1 个 PPTX 文件。";

export function validatePptxHomeHandoff(files: ReadonlyArray<{ name: string }>): string | undefined {
  if (files.length === 0) return undefined;
  if (files.length === 1 && files[0].name.toLowerCase().endsWith(".pptx")) return undefined;
  return PPTX_HANDOFF_ERROR;
}
